/**
 * Deze klasse handelt het aanpassen van een log af
 *
 * @history
 * 13 februari 2023
 * Start implementatie
 *
 */

import React from "react";
import {Popup} from "../../containers/Popup";

export class LogLikeForm extends React.Component {
    constructor(props) {
        super(props);

        this.state =
            {
                show_err: false,
                err_message: ""
            }


        this.inputTitle = React.createRef();
        this.inputText = React.createRef();

        this.storeClicked = this.storeClicked.bind(this);
        this.terugClicked = this.terugClicked.bind(this);

        this.formData = new FormData();

        this.formData.append("group_id", this.props.group_id);
        this.formData.append("access_id1",window.app.logboek.access_id1);
        this.formData.append("access_id2",window.app.logboek.access_id2);
        this.formData.append("kind","like");
        this.formData.append("location_id", this.props.location_id);

        if (this.props.action == "add")
        {
            this.form_url = "/add_log";
            this.props.log.title ="";
            this.props.log.data = "";
        }
        else
        {
            this.form_url ="/store_log";
            this.formData.append("id", this.props.log.id);
        }

    }


    terugClicked()
    {
        this.props.edit_done_callback(false);
    }

    storeClicked()
    {

        if (this.inputText.current.value == "")
        {
            this.setState({"show_err":true, "err_message":"Geen tekst ingevoerd. Probeer het opnieuw"});
            return false;
        }

        this.setState({"show_err":false});

        this.formData.append("text", this.inputText.current.value);
        const requestOptions = {
            method: 'POST',
            body: this.formData
        };

        fetch(this.form_url, requestOptions)
            .then(response => response.json())
            .then(log_json =>
            {
                if (log_json.status == "err")
                {
                    this.setState({"show_err":true, "err_message":"opslaan niet gelukt. Probeer het opnieuw"});

                }
                else
                {
                    this.setState({'login_err':false});
                    this.props.edit_done_callback(true, log_json.data);
                }
            });
    }


    render() {
        return (
        <Popup has_close_btn={false} title={""}>

                    <img src={"/digibord/assets/svgs/ui/like.svg"} className={"ui_icon"}/><br/>
                    <h2>Beschrijving</h2>
                    <textarea  className={"logger__textarea"} name={"description"}  ref={this.inputText}>{this.props.log.data}</textarea><br/>
                    <a href="javascript:void(0)" className={"button"} onClick={this.terugClicked}>Terug</a>
                    <a href="javascript:void(0)" className={"button"} onClick={this.storeClicked}>Opslaan</a>


                {this.state.show_err && (
                    <div style={{"float":"left","width":"100%","color":"#F00"}}>
                        <p>{this.state.err_message}</p>
                    </div>
                )}
          </Popup>

        );
    }

}
